import { gql } from '@grandvisionhq/graphql';

const lineItemPrice = gql`
  fragment LineItemPriceFragment on LineItemPrice {
    total {
      discount {
        amount
        percentage
        __typename
      }
      gross
      net
      subtotal
      tax {
        amount
        portions {
          amount
          rate
          __typename
        }
        __typename
      }
      __typename
    }
    unit {
      discount {
        amount
        percentage
        __typename
      }
      gross
      net
      subtotal
      tax {
        amount
        portions {
          amount
          rate
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
`;

export { lineItemPrice };
//# sourceMappingURL=line-item-price.js.map
